/* This components contains the routes for the Bingo Module */

import { Route, Routes } from "react-router-dom";

import { PlayBingoGamePresenter } from "bingo/play/views/PlayBingoGamePresenter";
//import { GamePlayThemeWrapper } from "quiz/layouts/GamePlayThemeWrapper";
import { BingoGamePlayThemeWrapper } from "bingo/layouts/BingoGamePlayThemeWrapper";

export function BingoGamePlayRoutes() {
  return (
    <Routes>
      <Route path="" element={<BingoGamePlayThemeWrapper />}>
        <Route path="" element={<PlayBingoGamePresenter />} />
      </Route>
      <Route path=":bingoGameId" element={<BingoGamePlayThemeWrapper />}>
        <Route path="" element={<PlayBingoGamePresenter />}></Route>
      </Route>
    </Routes>
  );
}
